import React from 'react'
import { useTranslation } from 'react-i18next'

import MetadataList from '~/components/dashboard/soapV2/summary/patient-details/MetadataList'

export interface DirectCommunicationProps {
  recipientEmail?: string | null
  recipientPhoneNumber?: string
}

const DirectCommunication = ({
  recipientEmail,
  recipientPhoneNumber,
}: DirectCommunicationProps) => {
  const { t } = useTranslation(['Common'])

  const isPhoneDirectCommunication = Boolean(recipientPhoneNumber)

  return (
    <MetadataList
      items={[
        {
          value: isPhoneDirectCommunication
            ? recipientPhoneNumber
            : recipientEmail,
        },
      ]}
      prefix={`${t('Common:To')}: `}
    />
  )
}

export default DirectCommunication
